import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Stylist } from '../../../models/stylist/stylist.model';
import { Booking } from '../../../models/booking/booking.model';
import { Service } from '../../../models/service/service.model';
import { Sale } from '../../../models/sale/sale.model';
import { UserService } from '../../../services/user.service';
import { StylistPickerComponent } from '../../../components/stylist-picker/stylist-picker.component';
import { BookingService } from '../../../services/booking.service';
import { DateRange } from '../../../utilities/utilities';

import { List } from 'immutable';
@Component({
  selector: 'app-sale-booking-picker',
  templateUrl: './sale-booking-picker.page.html',
  styleUrls: ['./sale-booking-picker.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaleBookingPickerPage implements OnInit {

  //@ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public bookings: List<Booking>;

  public excludeBookingGroupIds: List<number>;

  public isLoading: boolean;

  public stylistID: number;

  public readOnlyStylistPicker: boolean;

  @Input() sale: Sale;

  public startDate: Date;

  public endDate: Date;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingBookings: boolean;

  constructor (
    //private navParams: NavParams,
              private changeDetectorRef: ChangeDetectorRef,
              private bookingService: BookingService,
              private userService: UserService,
              private modalCtrl: ModalController
              ) {
    this.isLoading = true;
    this.bookings = List([]);
    this.excludeBookingGroupIds = List([]);
    this.isLoading = true;
    //this.sale = this.navParams.get('sale');

    if (this.sale) {
      this.sale.lineitems.forEach(lineitem => {
        if (lineitem.type === 'service') {
          const service: Service =  <Service> lineitem;
          this.excludeBookingGroupIds = this.excludeBookingGroupIds.push(service.getBookingGroupID())
        }
      });
    }

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }

    // show booking for "Today"
    this.startDate = new Date();
    this.endDate = new Date();
  }

  public ngOnInit () {

  }

  public onTapToReload () {
    this.isLoading = true;

    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      //this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingBookings) {
      this.errorOccurredWhileLoadingBookings = false;
      this.loadBookings();
    }
  }


  public onStylistPickerInit(initResponse: {success: boolean, stylist: Stylist}) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.stylistID = stylist.getID();
    this.loadBookings();
  }

  public rangeChanged (dateRange: DateRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.loadBookings();
  }

  public loadBookings () {

    if (isNaN(this.stylistID)) {
      throw new Error('stylistID is not required.');
    }

    const bookingStatusesToRead = [

      // requested
      // 2,

      //Unconfirmed
      3,

      // arrived
      4,

      // no show
      5,

      // paid
      // 8,

      // Reminded by phone
      9,

      // reminded by email
      10,

      // reminded by text
      11,

      // reminde by text & email
      12
    ];

    this.isLoading = true;
    this.errorOccurredWhileLoadingBookings = false;
    this.bookings = List([]);
    this.bookingService.loadBookings(this.startDate,this.endDate, this.stylistID, bookingStatusesToRead)
      .subscribe({
        next:(bookings) =>{
          this.bookings = bookings.filter((booking) => {
            if (booking.type === 'service' && !this.excludeBookingGroupIds.contains(booking.getId())) {
              return true;
            } else {
              return false;
            }
          }).toList();
          this.isLoading = false;
          this.changeDetectorRef.markForCheck();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingBookings = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  public onDismiss () {
    this.modalCtrl.dismiss();   
  }

  public bookingSelect (booking: Booking) {
    this.modalCtrl.dismiss(booking);   
  }


}
